import React from 'react';
import { Wifi, WifiOff } from 'lucide-react';

interface LiveIndicatorProps {
  isConnected: boolean;
  className?: string;
}

export default function LiveIndicator({ isConnected, className = '' }: LiveIndicatorProps) {
  return (
    <div className={`flex items-center gap-1.5 ${className}`}>
      <div className={`w-2 h-2 rounded-full ${
        isConnected
          ? 'bg-green-500 animate-pulse'
          : 'bg-red-500'
      }`} />
      <span className="text-xs text-gray-500 flex items-center gap-1">
        {isConnected ? (
          <>
            <Wifi size={12} className="text-green-500" />
            Live
          </>
        ) : (
          <>
            <WifiOff size={12} className="text-red-500" />
            Reconnecting...
          </>
        )}
      </span>
    </div>
  );
}
